export default __webpack_public_path__ + "static/media/sbj-mathematics.5e7c7cb6.svg";